module.exports = "<ng-container *ngIf=\"content | async as place\">\n    <ng-container *ngIf=\"place | meta\">\n        <marquee-row [item]=\"place | meta\" [disable]=\"true\"></marquee-row>\n        <detail-row [item]=\"place | meta\"></detail-row>\n        <ng-container *ngIf=\"(place | meta).content\">\n            <content-builder class=\"quote-block\" [items]=\"(place | meta).content\"></content-builder>\n        </ng-container>\n    </ng-container>\n    <rows [rows$]=\"place.rows\"></rows>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/place-container/place-container.component.html
// module id = 854
// module chunks = 2